import { render, staticRenderFns } from "./TakePayTable.vue?vue&type=template&id=64385142&scoped=true"
import script from "./TakePayTable.vue?vue&type=script&lang=js"
export * from "./TakePayTable.vue?vue&type=script&lang=js"
import style0 from "./TakePayTable.vue?vue&type=style&index=0&id=64385142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64385142",
  null
  
)

export default component.exports